import { useContext, useState } from 'react';
import { cn } from '@/helpers/utils/functionality-utils';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { LayoutContext } from '@/layout/context/context';
import { useNavigate } from 'react-router';

const ForgetPassword = () => {
  const { layoutConfig, theme } = useContext(LayoutContext);
  const [email, setEmail] = useState('');
  const nav = useNavigate();

  const containerClassName = cn(
    'flex min-h-screen min-w-[100vw] items-center justify-center overflow-hidden bg-surface-50',
    { 'p-input-filled': layoutConfig.inputStyle === 'filled' },
  );

  return (
    <div className={containerClassName}>
      <div className="flex flex-col items-center justify-center">
        <img
          src={`/assets/images/logo/logo-${
            theme === 'light' ? 'dark' : 'light'
          }-512.png`}
          alt="Sakai logo"
          style={{ height: '200px', width: '200px' }}
          className="mb-8 shrink-0"
        />
        <div
          style={{
            borderRadius: '56px',
            padding: '0.3rem',
            background:
              'linear-gradient(180deg, var(--primary-color) 10%, rgba(33, 150, 243, 0) 30%)',
          }}
        >
          <div
            className="smpx-8 w-full bg-surface-0 px-8 py-8"
            style={{ borderRadius: '53px' }}
          >
            <div className="mb-8 text-center">
              <span className="text-lg font-bold leading-10 text-surface-600">
                Forget Password
              </span>
            </div>

            <div>
              <label
                htmlFor="email"
                className="mb-2 block text-xl font-medium text-surface-900"
              >
                Email
              </label>

              <div className="flex flex-col items-center justify-center gap-4">
                <InputText
                  id="email"
                  type="text"
                  placeholder="Email address"
                  className="w-full md:w-[30rem]"
                  style={{ padding: '1rem' }}
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                />

                <Button
                  label="Request to send code"
                  className="w-full p-4 text-xl md:w-[30rem]"
                  onClick={() =>
                    nav('/auth/reset', {
                      viewTransition: true,
                    })
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
